import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import { PanelPage } from '../../../components/pages/pages';

import {
  addOrderToWave, getOpenWaveList,
  getOutboundWavesProductsList,
  getOptionsPriorities,
} from '../../../app/store/actions/outboundWaves';
import { getUserByRange } from '../../../app/store/actions/ranges';
import OneClickButton from '../../../components/form/button';
import Select from '../../../components/form/select';
import addNotification from '../../../components/notification';

import PickingWave from './pickingWave';
import TableWave from './tableWave';

import WikiHelp from '../../../components/tooltip/wikiHelp';
import ROUTES from '../../../config/routes';

class OutboundOrderPickingWave extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      productsList: [],
      rangeList: [],
      priorityList: [],
      outboundWavesList: [],
      activateAddButton: true,
      page: 1,
      rangeCode: null,
      rangeName: '',
      priorityCode: null,
      priorityName: '',
      loadNumber: '',
      rangeDisabled: false,
      addNew: false,
    };
  }

  async componentDidMount() {
    await this.selectPage();
  }

  setValueDrop = async (attr, value) => {
    await this.setState({
      [`${attr}Code`]: value ? value.value : null,
      [`${attr}Name`]: value ? value.label : '',
    });
  };

  setValue = async (attr, value) => {
    await this.setState({
      [`${attr}`]: value,
    });
  };

  createSelectDropDown = (value, attr, label, items, disabled, id, keypressFunction = undefined) => (
    <div className="form-group m-b-15 text-left">
      <label htmlFor={id && id}>{label}</label>
      <div>
        <Select
          id={id && id}
          onKeyDown={keypressFunction && ((e) => keypressFunction(e, id, attr))}
          value={value.label ? value : ''}
          onChange={(e) => this.setValueDrop(attr, e)}
          options={items}
          styles={this.colourStyles}
          placeholder={I18n.t('BEE144' /* Selecione... */)}
          isDisabled={disabled}
        />
      </div>
    </div>
  );

  createInput = (
    value,
    attr,
    label,
    placeholder,
    type = 'text',
    required,
    disabled,
    keypressFunction = undefined,
    id = null,
  ) => (
    <div className="form-group p-2 text-left">
      <label htmlFor={id && id}>{label}</label>
      <input
        onKeyDown={keypressFunction && ((e) => keypressFunction(e, id, attr))}
        id={id && id}
        type={type}
        className="form-control"
        value={value || ''}
        onChange={(e) => this.setValue(attr, e.target.value)}
        placeholder={disabled ? '' : placeholder}
        required={required}
        disabled={disabled}
      />
    </div>
  );

  selectPage = async () => {
    const outboundWavesList = await this.props.getOpenWaveList();

    if (outboundWavesList) {
      const { waveRangesList = [], status = 0 } = outboundWavesList;
      if (waveRangesList.length && status === 2) {
        const productsList = await this.props.getOutboundWavesProductsList(waveRangesList[0].id) || [];

        this.setState({
          productsList,
          activateAddButton: false,
          page: 2,
          rangeDisabled: true,
        });
      } else {
        this.setState({
          outboundWavesList: outboundWavesList.waveRangesList,
          activateAddButton: true,
          page: 1,
          rangeDisabled: true,
          rangeCode: waveRangesList.length ? waveRangesList[0].outboundWaveRangeCode : '',
          priorityCode: waveRangesList.length ? waveRangesList[0].outboundWavePriorityCode : '',
          loadNumber: waveRangesList.length ? waveRangesList[0].outboundWaveLoadNumber : '',
          rangeName: (waveRangesList.length && (waveRangesList[0].outboundWaveRangeCode === 'all'
            ? I18n.t('BEE793' /* Todos */) : waveRangesList[0].outboundWaveRangeName)) || '',
          priorityName: (waveRangesList.length && (waveRangesList[0].outboundWavePriorityCode === 'all'
            ? I18n.t('BEE793' /* Todos */) : waveRangesList[0].outboundWavePriorityName)) || '',
        });
        await this.getUserByRange();
        await this.getOptionsPriorities();
      }
    } else {
      this.setState({
        outboundWavesList: [],
        activateAddButton: true,
        page: 1,
        rangeDisabled: false,
      });
      await this.getUserByRange();
      await this.getOptionsPriorities();
      if (this.state.rangeList.length && !this.state.rangeCode) {
        this.setState({
          rangeCode: 'all',
          rangeName: I18n.t('BEE793' /* Todos */),
        });
      }
      if (this.state.priorityList.length && !this.state.priorityCode) {
        this.setState({
          priorityCode: 'all',
          priorityName: I18n.t('BEE793' /* Todos */),
        });
      }
    }
  };

  addOrderToWave = async () => {
    const {
      rangeCode, rangeList, priorityCode, loadNumber,
    } = this.state;
    if (!rangeList.length) {
      addNotification(
        'danger',
        I18n.t('BEE1446' /* Separação por Onda */),
        I18n.t('BEE2066' /* O usuário não está vinculado a nenhum range */),
        'top-right',
      );
    } else if (!rangeCode) {
      addNotification(
        'danger',
        I18n.t('BEE1446' /* Separação por Onda */),
        I18n.t('BEE2043' /* Nenhum range selecionado */),
        'top-right',
      );
    } else {
      try {
        const result = await this.props.addOrderToWave(rangeCode, priorityCode, loadNumber);

        if (result && result.success === false) {
          addNotification(
            'danger',
            I18n.t('BEE1446' /* Separação por Onda */),
            I18n.t('BEE1841' /* Nenhum Documento de Saída pendente para o usuário! */),
            'top-right',
          );
          await this.selectPage();
        } else {
          await this.selectPage();
          this.setState({ addNew: true });
        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error) {
          const { error } = err.response.data;

          if (error.details || error.message) {
            addNotification(
              'danger',
              I18n.t('BEE1446' /* Separação por Onda */),
              `${error.code} - ${error.details || error.message}`,
              'top-right',
            );
          } else {
            addNotification(
              'danger',
              I18n.t('BEE1446' /* Separação por Onda */),
              I18n.t('BEE1842' /* Erro ao buscar documento para separação */),
              'top-right',
            );
          }
        } else {
          addNotification(
            'danger',
            I18n.t('BEE1446' /* Separação por Onda */),
            I18n.t('BEE1842' /* Erro ao buscar documento para separação */),
            'top-right',
          );
        }
      }
    }
  };

  getUserByRange = async () => {
    try {
      const rangeList = await this.props.getUserByRange();
      if (rangeList && rangeList.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE1446' /* Separação por Onda */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      } else {
        if (!rangeList.length) {
          addNotification(
            'danger',
            I18n.t('BEE1446' /* Separação por Onda */),
            I18n.t('BEE2066' /* O usuário não está vinculado a nenhum range */),
            'top-right',
          );
          this.setState({ rangeDisabled: true });
        }
        this.setState({ rangeList });
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        addNotification('danger', I18n.t('BEE1446' /* Separação por Onda */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1446' /* Separação por Onda */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      }
    }
  };

  getOptionsPriorities = async () => {
    try {
      const priorityList = await this.props.getOptionsPriorities();
      if (priorityList && priorityList.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE1446' /* Separação por Onda */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      } else {
        priorityList.unshift({ value: 'all', label: I18n.t('BEE793' /* Todos */) });
        this.setState({ priorityList });
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        addNotification('danger', I18n.t('BEE1446' /* Separação por Onda */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1446' /* Separação por Onda */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      }
    }
  };

  render() {
    const {
      page, outboundWavesList, productsList,
      rangeList = [], rangeCode, rangeName, rangeDisabled,
      priorityList = [], priorityCode, priorityName, loadNumber,
    } = this.state;
    const { userLogged } = this.props;
    const pickingByLoad = userLogged && userLogged.mainBranchData
      ? userLogged.mainBranchData.pickingByLoad
      : false;

    return (
      <>
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1400' /* Movimentação */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE41' /* Expedição */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE1446' /* Separação por Onda */)}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center">
          <h1 className="page-header mb-0">
            {I18n.t('BEE1446' /* Separação por Onda */)}
          </h1>
          <WikiHelp wikiPath={ROUTES.OUTBOUND_WAVE_PICKING_HELP} />
          {this.state.activateAddButton && (
            <div className="ml-auto">
              <OneClickButton
                className="btn btn-success btn-sm btn-rounded pl-2 pr-3"
                onClick={() => this.addOrderToWave()}
              >
                <i className="fa fa-plus mr-2" />
                {I18n.t('BEE407' /* Buscar */)}
              </OneClickButton>
            </div>
          )}
        </div>
        {page === 1 && (
          <PanelPage
            content={(
              <div className="row">
                <div className="col mr-2">
                  {this.createSelectDropDown(
                    { value: rangeCode, label: rangeName },
                    'range',
                    `${I18n.t('BEE581' /* Range */)}: `,
                    rangeList,
                    rangeDisabled,
                    1,
                  )}
                </div>
                <div className="col ml-5">
                  {this.createSelectDropDown(
                    { value: priorityCode, label: priorityName },
                    'priority',
                    `${I18n.t('BEE4115' /* Prioridade */)}: `,
                    priorityList,
                    rangeDisabled,
                    2,
                  )}
                </div>
                { pickingByLoad && (
                <div className="col ml-5">
                  {this.createInput(
                    loadNumber,
                    'loadNumber',
                    I18n.t('BEE4526' /* Carga */),
                    '',
                    'text',
                    false,
                    rangeDisabled,
                  )}
                </div>
                )}
              </div>
            )}
          />
        )}
        {page === 1 && (
          <TableWave
            outboundWavesList={outboundWavesList}
            selectPage={() => this.selectPage()}
            addNew={this.state.addNew}
            setState={(value) => this.setState(value)}
          />
        )}
        {page === 2 && (
          <PickingWave
            selectPage={() => this.selectPage()}
            productsList={productsList}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userLogged: state.app && state.app.userLogged,
});

const mapDispatchToProps = (dispatch) => ({
  getOpenWaveList: () => dispatch(getOpenWaveList()),
  getOutboundWavesProductsList: (outboundWaveId) => dispatch(getOutboundWavesProductsList(outboundWaveId)),
  addOrderToWave: (
    rangeCode,
    priorityCode,
    loadNumber,
  ) => dispatch(addOrderToWave(rangeCode, priorityCode, loadNumber)),
  getUserByRange: () => dispatch(getUserByRange()),
  getOptionsPriorities: () => dispatch(getOptionsPriorities()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OutboundOrderPickingWave));
